import { Component, Input, ChangeDetectionStrategy, signal } from '@angular/core';
import { ConversionStatResolution, GetConversionStat } from 'src/app/generated-client/generated-client';

import { AreaChartModule, Color, ScaleType } from '@swimlane/ngx-charts';
import { DecimalPipe } from '@angular/common';
import moment from 'moment';

@Component({
  selector: 'da-stats-overview-graph',
  templateUrl: './stats-overview-graph.component.html',
  styleUrls: ['./stats-overview-graph.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AreaChartModule, DecimalPipe]
})
export class StatsOverviewGraphComponent {
  @Input() resolution: ConversionStatResolution;
  @Input() set stats(value: GetConversionStat[]) {
    if (!value || !value.length) {
      return;
    }

      const dataSet = [
      {
        name: 'Conversions',
        series: value.map(stat => {
          return {
            name: this.resolution === ConversionStatResolution.Year ? moment(stat.dateUtc).format('YYYY') : moment(stat.dateUtc).toDate(),
            value: stat.conversions
          };
        })
      }
    ];
    this.dataSet.set(dataSet);
    this.totalConversions.set(dataSet[0].series.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.value;
    }, 0));
    this.timeline.set(this.resolution !== ConversionStatResolution.Year);
  }

  dataSet = signal<{
    name: string;
    series: { name: string | Date; value: number }[];
  }[]>(null);
  totalConversions = signal(0);
  showLabels = true;
  animations = true;
  timeline = signal(true);
  colorScheme: Color = {
    name: 'dangl-avacloud',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#00acc1']
  };
}
